// Sentry へ warning を 1 件送る薄いラッパ。Sentry 未 init (DSN 無し / dev / test) でも
// `captureMessage` は no-op なので throw しない (念のため try/catch)。

import * as Sentry from '@sentry/react';

export const captureWarning = (message: string, extra: Record<string, unknown>): void => {
  try {
    Sentry.captureMessage(message, { level: 'warning', extra });
  } catch {
    // best-effort
  }
};
